<template>
  <vs-popup class="create-csutomer-crm-opportunity" id="popup"
    :title="isCreateMode ? `CREATE VAM` : `UPDATE VAM`" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-csutomer-crm-opportunity-popup" @submit.prevent="handleSubmit(onClickCreateSite)"
          autocomplete="off">

          <div class="vx-row mb-3 vx-card card-border no-shadow ml-0 py-3 hidden" v-if="form.product_orders.length > 0 && !isCreateMode">
            <div class="vx-col w-full">
              <h5 class="mb-3">Linked SO</h5>
              <span v-for="(order, index) in form.product_orders" :key="index">
                <span @click.stop="onClickOpenSo(order.id)" class="text-primary cursor-pointer">{{ order.product_order_code }}</span> <br>
              </span>
            </div>
          </div>


          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="date" name="date" rules="required" v-slot="{ errors }">
                <small class="label">Date</small>
                <flat-pickr :config="{ enableTime: true, dateFormat: 'd/m/Y' }" class="hidden" v-model="form.date"
                  placeholder="Choose Date" />
                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="w-full" v-model="form.date"
                  placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vx-card cardBorder noShadow class="my-3" title="Linked Sales Order(s) & Item(s)">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="product_orders" name="product_orders" rules="" v-slot="{ errors }">
                  <small class="label">Sales Order(s)</small>
                  <v-select multiple :clearable="false" :closeOnSelect="true" name="project_briefs" placeholder=""
                    label="name" v-model="form.product_orders" :reduce="option => option" :options="sales_orders"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :filter-by="soFilter" @input="onInputSalesOrder">
                    <template slot="option" slot-scope="option">
                      <span>{{ option.product_order_code }} <span v-if="!!option.name"> - {{ option.name }}</span> </span>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <span>{{ option.product_order_code }}</span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="product_order_items" name="product_order_items" rules="" v-slot="{ errors }">
                  <small class="label">Sales Order Items(s)</small>
                  <v-select multiple :clearable="false" :closeOnSelect="true" name="project_briefs" placeholder=""
                    label="code" v-model="form.product_order_items" :reduce="option => option" :options="sales_order_items"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template slot="option" slot-scope="option">
                      <span>{{ option.code }} <span v-if="!!option.formulation"> - {{ option.formulation }}</span> </span>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <span>{{ option.code }}</span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">VAM Type(s)</small>
                <v-select :clearable="false" :closeOnSelect="true" name="type" placeholder="" label="name" multiple
                  v-model="form.type" :reduce="option => option.name" :options="vam_types" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="max:5000|required" v-slot="{ errors }">
                <small class="label">Description</small>
                <small class="label float-right text-warning font-bold">{{ form.description.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.description" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 mt-4 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="staff" name="staff" rules="required" v-slot="{ errors }">
                <small class="label">ITS Staff Involved</small>
                <v-select name="staff" :closeOnSelect="false" :clearable="false" v-model="form.staff"
                  :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name"
                  multiple />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="project_briefs" name="project_briefs" rules="" v-slot="{ errors }">
                <small class="label">Project Brief</small>
                <v-select multiple :clearable="false" :closeOnSelect="false" name="project_briefs" placeholder=""
                  label="name" v-model="form.project_briefs" :reduce="option => option.id" :options="project_brief_list"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <span>{{ option.name }} - {{ option.project_brief_code }}</span>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <span>{{ option.name }} - {{ option.project_brief_code }}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="value_to_customer" name="value_to_customer" rules="" v-slot="{ errors }">
                <small class="label">Value to Customer</small>
                <vs-input v-model="form.value_to_customer" name="value_to_customer" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="cost_to_company" name="cost_to_company" rules="" v-slot="{ errors }">
                <small class="label">Cost to Company</small>
                <vs-input v-model="form.cost_to_company" name="cost_to_company" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="max:5000" v-slot="{ errors }">
                <small class="label">Notes</small>
                <small class="label float-right text-warning font-bold">{{ form.notes.length }}/5000</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="100px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const DropDownRepository = RepositoryFactory.get('drop_down')
const CrmRepository = RepositoryFactory.get('crm')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import vSelect from 'vue-select'

import { mapActions, mapGetters } from 'vuex';

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      staff: [],
      type: [],
      date: null,
      notes: '',
      description: '',
      project_briefs: [],
      value_to_customer: '',
      cost_to_company: '',
      product_orders: [],
      product_order_items: []
    },
    isCreateMode: true,
    customer_users_list: [],
    selected_customer_users_ids: [],
    selected_customer_users: [],
    subjects_list: [],
    customerSources: [],
    customerSubSources: [],
    project_brief_list: [],
    product_list: [],
    vam_types: [],
    sales_orders: [],
    sales_order_items: []
  }
}

export default {
  name: 'CreateCustomerCrmSnapshotPopUp',
  data() {
    return initialState()
  },
  props: {
    customer_id: {
      default: ''
    }
  },
  methods: {
    ...mapActions(['fetchStaffs']),
    async openPopup(id, product_order = null) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchStaffs()
        await this.fetchProjectBriefs()
        await this.fetchSnapVamTypes()
        await this.fetchSalesOrders()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchOpportunityDetails()
        } else {
          this.isCreateMode = true
          if(product_order) {
            this.form.product_orders.push({
              product_order_code: product_order.product_order_code,
              id: product_order.id
            })
            this.sales_order_items = product_order.formulation_items.map(po => ({ id: po.id, code: po.formulation_code, formulation: po.formulation_name }))
          }
        }
      } catch (error) {
        
      }
    },
    async fetchProjectBriefs() {
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        const { data } = (await DropDownRepository.getProjectBriefDropDownList(`filter[customer_id]=${this.customer_id}`)).data
        this.project_brief_list = data
      } catch (error) {

      } finally {
        this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
      }
    },
    async fetchSnapVamTypes() {
      try {
        const { data } = (await CrmRepository.getListVamType()).data
        this.vam_types = data
      } catch (error) {

      }
    },
    async fetchOpportunityDetails() {
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        const res = await CrmRepository.getCustomerCrmSnapshot(this.id)
        const data = res.data.data
        this.form = {
          ...data,
          staff: data.staff.map(s => s.id),
          project_briefs: data.project_briefs.map(p => p.id),
          product_orders: data.product_orders.map(o => ({
            id: o.id,
            product_order_code: o.product_order_code
          })),
          product_order_items: data.product_order_items.map(i => ({
            id: i.id,
            code: i.formulation_code,
            formulation: i.formulation_name
          }))
        }
        const orderIds = new Set(this.form.product_orders.map(o => o.id))
        this.sales_order_items = this.sales_orders
          .filter(so => orderIds.has(so.id))
          .flatMap(so => so.items)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
    },
    async onClickCreateSite() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        let payload = {}
        Object.assign(payload, this.form)
        if (this.isCreateMode) {
          payload.customer_id = this.customer_id
          payload.product_orders = payload.product_orders.map(order => order.id)
          payload.product_order_items = payload.product_order_items.map(order => order.id)
          await CrmRepository.createCustomerSnapshot(payload);
          this.showSuccessMessage('Customer crm VAM added!');
        } else {
          payload.product_orders = payload.product_orders.map(order => order.id)
          payload.product_order_items = payload.product_order_items.map(order => order.id)
          await CrmRepository.updateCustomerCrmSnapshot(this.id, payload);
          this.showSuccessMessage('Customer crm VAM updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
    },
    onClickOpenSo(id) {
      const route = this.$router.resolve({ path: `/pages/product-orders/${id}` });
      window.open(route.href, '_blank');
    },
    onInputSalesOrder() {
      this.sales_order_items = []
      const items = this.form.product_orders.map(x => x.items).flat()
      this.sales_order_items = items
    },
    soFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.product_order_code.toLowerCase().indexOf(temp) > -1 ||
        option.name.toLowerCase().indexOf(temp) > -1
    },
    async fetchSalesOrders() {
      await this.$vs.loading({
        container: '#create-csutomer-crm-opportunity-popup',
        scale: 0.45
      })
      try {
        const { data } = (await DropDownRepository.getAllProductOrderList()).data
        this.sales_orders = data
      } catch (error) {
        
      } finally {
        this.$vs.loading.close('#create-csutomer-crm-opportunity-popup > .con-vs-loading')
      }
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect
  },
  computed: {
    ...mapGetters(['staffs'])
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-csutomer-crm-opportunity>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}
</style>
